<template>
  <section class="call-to-action">
    <b-container>
      <b-row>
        <b-col>
          <div class="action-warpper">
            <div class="icon">
              <img src="/img/icons/png/point4.png" alt="" />
            </div>
            <div class="text">
              <h4>Become an Instructor</h4>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Expedita neque fugiat deserunt voluptate repellendus, suscipit
                perferendis nulla.
              </p>
            </div>
          </div>
          <b-button pill variant="primary" @click="goToRegistration"
            >Register Now</b-button
          >
        </b-col>
        <b-col>
          <div class="action-warpper">
            <div class="icon">
              <img src="/img/icons/png/edofre-icons-2-request.png" alt="" />
            </div>
            <div class="text">
              <h4>Request a Course</h4>
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Expedita neque fugiat deserunt voluptate repellendus, suscipit
                perferendis nulla.
              </p>
            </div>
          </div>
          <b-button pill variant="primary" @click="goToRequest"
            >Request Now</b-button
          >
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
export default {
  name: "call_to_action",
  methods: {
    goToRegistration() {
      this.$router.push("/become_a_teacher");
    },
    goToRequest() {
      this.$router.push("/request_course");
    }
  }
};
</script>

<style></style>
